export const TRADES_TABLE_CONSTANTS = {
  PAGINATION: {
    DEFAULT_PAGE: 0,
    DEFAULT_PAGE_SIZE: 25,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  },
  AUTOSIZE: {
    columns: ['id'] as string[],
    includeHeaders: true,
    includeOutliers: true,
  },
  EMPTY_STATE: {
    ICON_SIZE: 150,
    TITLE_FONT_SIZE: 36,
    PADDING: '40px 20px',
  },
} as const;
